var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bookmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 2.79999C3.5 2.42869 3.6475 2.0726 3.91005 1.81004C4.1726 1.54749 4.5287 1.39999 4.9 1.39999H9.1C9.4713 1.39999 9.8274 1.54749 10.0899 1.81004C10.3525 2.0726 10.5 2.42869 10.5 2.79999V12.6L7 10.85L3.5 12.6V2.79999Z",
    fill: "#7B09C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.eafab54445fdfc1b74105fac6f7bf3b9.svg";
export { ForwardRef as ReactComponent };